import { useEffect, useState } from "react";
import { fetchNewspapers } from "../services/newspaperService";
import { Link } from "react-router-dom";

import "../assets/css/home.css";
import Introduction from "../components/Introduction";
import HeroSection from "../components/HeroSection";
import Seo from "../components/Seo";
import GoogleAnalytics from "../components/GoogleAnalytics";

const Home = () => {
    const [newspapers, setNewspapers] = useState([]);

    useEffect(() => {
        fetchNewspapers(3).then(setNewspapers);
    }, []);

    console.log(newspapers);
    
    return (
        <>
            <Seo canonical="/" />
            {/* Home page only - see src/components/GoogleAnalytics.jsx */}
            <GoogleAnalytics />
            <HeroSection pageType="home" />
            <div className="newspaper-container-wrapper">
                <Introduction />
            </div>
            <div className="newspaper-tiles-wrapper">
                <div className="container py-5">
                    <h3>Recent news</h3>
                    <div className="row">
                        {newspapers.map(news => (
                            <div className="col-lg-4 col-md-4 col-12 mb-3" key={news.id}>
                                <div className="card">
                                    <Link className="newspaper-div" to={`/read/${news.slug}`}>
                                        <img src={news.image_url} className="card-img-top" alt={news.title} />
                                        <div className="card-body">
                                            <h5 className="mb-3">{news.title}</h5>
                                            <div className="d-flex justify-content-between">
                                                <p className="mb-0">{news.date}</p>
                                                <p className="mb-0">Read More</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );

};

export default Home;

